module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c6e5129e936855db5a1181a778a3b94.svg";